var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from './UsersImportModal.module.scss';
import { Modal } from 'src/ui/components/modal/Modal';
import { Button, EButtonType } from 'src/ui/components/button/Button';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { E_FILE_INPUT_ERROR, E_FILE_SIZE, FileInput } from 'src/ui/components/Input/FileInput/FileInput';
import { useState } from 'react';
import { FILE_ACCEPTED_TYPES, MAX_USER, REQUIRED_CSV_FILE_HEADERS, } from 'src/ui/views/users/components/UsersImportModal/constants';
import { UsersImportTuto } from 'src/ui/views/users/components/UsersImportModal/components/UsersImportTuto/UsersImportTuto';
import { UsersImported } from 'src/ui/views/users/components/UsersImportModal/components/UsersImported/UsersImported';
import { downloadErrorCsv } from 'src/ui/views/users/components/UsersImportModal/helpers/downloadErrorCSV';
import { readContentFile } from 'src/shared/helpers/fileHelpers';
export var E_USER_IMPORT_ERROR;
(function (E_USER_IMPORT_ERROR) {
    E_USER_IMPORT_ERROR["FILE_EMPTY"] = "FILE_EMPTY";
    E_USER_IMPORT_ERROR["HEADER_EMPTY"] = "HEADER_EMPTY";
    E_USER_IMPORT_ERROR["NO_HEADER_SEPARATOR"] = "NO_HEADER_SEPARATOR";
    E_USER_IMPORT_ERROR["WRONG_HEADER_SEPARATOR"] = "WRONG_HEADER_SEPARATOR";
    E_USER_IMPORT_ERROR["MISSING_REQUIRED_HEADERS"] = "MISSING_REQUIRED_HEADERS";
    E_USER_IMPORT_ERROR["NO_USER_FOUND"] = "NO_USER_FOUND";
    E_USER_IMPORT_ERROR["TOO_MANY_USERS"] = "TOO_MANY_USERS";
})(E_USER_IMPORT_ERROR || (E_USER_IMPORT_ERROR = {}));
export var UsersImportModal = function (props) {
    var i18n = props.i18n, isImportLoading = props.isImportLoading, result = props.result, onClose = props.onClose, onImport = props.onImport, onReset = props.onReset;
    var _a = useState(null), fileErrorMessage = _a[0], setFileErrorMessage = _a[1];
    var _b = useState(null), currentFile = _b[0], setCurrentFile = _b[1];
    var _c = useState(null), users = _c[0], setUsers = _c[1];
    var title = getPropsByKeyPath(i18n, 'components.importUsersModal.importUsersTitle');
    var confirmButtonLabel = result
        ? getPropsByKeyPath(i18n, 'keyValueMap.common.startAgain')
        : getPropsByKeyPath(i18n, 'components.importUsersModal.confirmButtonLabel');
    var cancelButtonLabel = getPropsByKeyPath(i18n, 'components.importUsersModal.cancelButtonLabel');
    var inputDownloadLabel = getPropsByKeyPath(i18n, 'components.importUsersModal.chooseCSVFileButtonLabel');
    var handleFileLoading = function (fileContent) {
        var _a;
        var isEmptyFile = fileContent.trim().length === 0;
        if (isEmptyFile) {
            handleFileError(E_USER_IMPORT_ERROR.FILE_EMPTY);
            return;
        }
        var fileRows = fileContent.split(/\n/g);
        var headersRow = (_a = fileRows[0]) === null || _a === void 0 ? void 0 : _a.trim();
        if ((headersRow === null || headersRow === void 0 ? void 0 : headersRow.length) === 0) {
            handleFileError(E_USER_IMPORT_ERROR.HEADER_EMPTY);
            return;
        }
        var haveRightSeparator = headersRow.includes(';');
        var haveWrongSeparator = headersRow.includes(',');
        if (!haveRightSeparator && !haveWrongSeparator) {
            handleFileError(E_USER_IMPORT_ERROR.NO_HEADER_SEPARATOR);
            return;
        }
        else if (haveWrongSeparator) {
            handleFileError(E_USER_IMPORT_ERROR.WRONG_HEADER_SEPARATOR);
            return;
        }
        var headers = headersRow.split(';');
        var missingHeaders = REQUIRED_CSV_FILE_HEADERS.filter(function (header) { return !headers.some(function (h) { return h.trim() === header; }); });
        // Specific error for missing required headers, so we don't use handleFileError
        if (missingHeaders.length > 0) {
            handleFileError(E_USER_IMPORT_ERROR.MISSING_REQUIRED_HEADERS);
            var missingHeaderText = getPropsByKeyPath(i18n, 'components.importUsersModal.error.preCheck.missingHeaders');
            setFileErrorMessage("".concat(missingHeaderText, " ").concat(missingHeaders.join(',')));
            return;
        }
        var users = fileRows.slice(1).filter(function (row) { return row.trim().length > 0; });
        if (users.length === 0) {
            handleFileError(E_USER_IMPORT_ERROR.NO_USER_FOUND);
            return;
        }
        else if (users.length > MAX_USER) {
            handleFileError(E_USER_IMPORT_ERROR.TOO_MANY_USERS);
            return;
        }
        else {
            setUsers(users);
        }
    };
    var handleFileChange = function (file) {
        setFileErrorMessage(null);
        setUsers(null);
        setCurrentFile(file);
        readContentFile(file)
            .then(function (content) {
            handleFileLoading(content);
        })
            .catch(function (error) {
            handleFileError(E_FILE_INPUT_ERROR.LOADING_ERROR);
            setCurrentFile(null);
        });
    };
    var handleFileError = function (type, file) {
        switch (type) {
            case E_FILE_INPUT_ERROR.FILE_TYPE:
                var invalidFileTypeText = getPropsByKeyPath(i18n, 'components.importUsersModal.error.preCheck.invalidFileType');
                setFileErrorMessage(invalidFileTypeText);
                break;
            case E_FILE_INPUT_ERROR.FILE_SIZE:
                var invalidFileSizeText = getPropsByKeyPath(i18n, 'components.importUsersModal.error.preCheck.invalidFileSize');
                setFileErrorMessage(invalidFileSizeText);
                break;
            case E_FILE_INPUT_ERROR.LOADING_ERROR:
                var errorReadingFileText = getPropsByKeyPath(i18n, 'components.importUsersModal.error.preCheck.errorReadingFile');
                setFileErrorMessage(errorReadingFileText);
                break;
            case E_USER_IMPORT_ERROR.FILE_EMPTY:
                var emptyFileText = getPropsByKeyPath(i18n, 'components.importUsersModal.error.preCheck.emptyFile');
                setFileErrorMessage(emptyFileText);
                break;
            case E_USER_IMPORT_ERROR.HEADER_EMPTY:
                var noHeaderLineText = getPropsByKeyPath(i18n, 'components.importUsersModal.error.preCheck.noHeaderLine');
                setFileErrorMessage(noHeaderLineText);
                break;
            case E_USER_IMPORT_ERROR.NO_HEADER_SEPARATOR:
                var columnSeparatorNotFoundText = getPropsByKeyPath(i18n, 'components.importUsersModal.error.preCheck.columnSeparatorNotFound');
                setFileErrorMessage(columnSeparatorNotFoundText);
                break;
            case E_USER_IMPORT_ERROR.WRONG_HEADER_SEPARATOR:
                var invalidColumnSeparatorText = getPropsByKeyPath(i18n, 'components.importUsersModal.error.preCheck.invalidColumnSeparator');
                setFileErrorMessage(invalidColumnSeparatorText);
                break;
            case E_USER_IMPORT_ERROR.NO_USER_FOUND:
                var noUsersText = getPropsByKeyPath(i18n, 'components.importUsersModal.error.preCheck.noUsers');
                setFileErrorMessage(noUsersText);
                break;
            case E_USER_IMPORT_ERROR.TOO_MANY_USERS:
                var tooManyUsersText = getPropsByKeyPath(i18n, 'components.importUsersModal.error.preCheck.tooManyUsers');
                setFileErrorMessage(tooManyUsersText);
                break;
        }
        setCurrentFile(null);
    };
    var handleConfirmClick = function () {
        if (result) {
            onReset();
            setCurrentFile(null);
        }
        else {
            if (currentFile) {
                onImport(currentFile);
            }
        }
    };
    var handleDownloadErrorCsv = function () {
        var info = result === null || result === void 0 ? void 0 : result.info;
        readContentFile(currentFile)
            .then(function (content) {
            downloadErrorCsv(content, info);
        })
            .catch(function (error) { });
    };
    var buttonDisabled = !currentFile || !!fileErrorMessage;
    var userText = getPropsByKeyPath(i18n, 'keyValueMap.common.user');
    var nbOfUsers = (users === null || users === void 0 ? void 0 : users.length) || 0;
    return (_jsxs(Modal, __assign({ title: title, onClose: onClose, className: styles.userImportModalContentWrapper }, { children: [_jsx("div", __assign({ className: styles.userImportModalContent }, { children: result ? (_jsx(UsersImported, { i18n: i18n, result: result, onDownloadErrorCsv: handleDownloadErrorCsv })) : (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: styles.userImportModalContentInput }, { children: [_jsx(FileInput, { file: currentFile, placeholder: inputDownloadLabel, typesAccepted: FILE_ACCEPTED_TYPES, limitSize: E_FILE_SIZE.ONE_MO, withInfo: true, isError: !!fileErrorMessage, infoMessage: fileErrorMessage, onFileChange: handleFileChange, onError: handleFileError }), !!nbOfUsers && (_jsxs("span", __assign({ className: styles.userImportModalContentUserFounded }, { children: [nbOfUsers, " ", userText, nbOfUsers > 1 ? 's' : ''] })))] })), _jsx(UsersImportTuto, { i18n: i18n })] })) })), _jsxs("div", __assign({ className: styles.actionsWrapper }, { children: [_jsx(Button, { type: EButtonType.NEUTRAL, isEdge: true, label: cancelButtonLabel, onClick: onClose }), _jsx(Button, { type: EButtonType.NEUTRAL, label: confirmButtonLabel, onClick: handleConfirmClick, disabled: buttonDisabled, isLoading: isImportLoading })] }))] })));
};
